// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  SupportEmailId: 'digital.support@diversey.com',
  MAPS_API_URL: 'https://maps.googleapis.com/maps/api/geocode/json?address=',
  MAPS_TIMEZONE_API_URL: 'https://maps.googleapis.com/maps/api/timezone/json?location=',
  MAPS_TIMEZONE_API_KEY: '',
  NODE_URL: 'https://pac.diverseyiot.com/api/v1/',
  DASHBOARD_HOST_URL: 'https://dashboard.diverseyiot.com/',
  PAC_HOST_URL: 'https://pac.diverseyiot.com/',
  COOKIE_DOMAIN_NAME: '.diverseyiot.com',
  OKTA_COOKIE_DOMAIN_NAME: 'dashboard.diverseyiot.com',
  COOKIE_PREFIX: 'prod_',
  TERMS_CONDITIONS: 'https://www.solenis.com/en/terms-conditions',
  DOMAIN_PREFIX: '',
  OKTA_DOMAIN: 'https://diversey.okta.com',
  OKTA_ISSUER: 'https://diversey.okta.com',
  OKTA_CLIENT_ID: '0oao8pz65yFKPCiGt357',
  SOLENIS_EMAIL_MIGRATION_SOURCE_EMAILS: [{
    suffix: '@diversey.com',
    name: 'Diversey'
  },
  {
    suffix: '@lilleborg.no',
    name: 'Lilleborg'
  }]
};
